import { render, staticRenderFns } from "./SchoolQrCodeGuide.vue?vue&type=template&id=6818a8bc&"
import script from "./SchoolQrCodeGuide.vue?vue&type=script&lang=js&"
export * from "./SchoolQrCodeGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports